import * as React from 'react';
import { observer } from 'mobx-react';
import { ReleaseHeader } from './release-header';
import { ArtistSchema, ReleaseSchema, TrackSchema } from '../types/schema';
import { ImagePreloader } from '../types/fn';
import { TrackLine } from './project-happy/molecules/TrackLine';
import { style } from 'typestyle';
import { colorLightGrey } from '../theme/color';
import { spacing } from '../theme/spacing';
import { Loading } from './loading/loading';

export interface ReleaseModel {
  artist: ArtistSchema;
  release: ReleaseSchema;
  tracks: Array<TrackSchema>;
  loading: boolean;
  loadingPage: number;
}

export interface ReleaseProps {
  model: ReleaseModel;
  onClickLink(event: React.MouseEvent<any>): void;
}

const styles = {
  release: style({
    $nest: {
      '& + *': {
        marginTop: spacing.XLARGE,
      },
    },
  }),
};

export const Release: React.FC<ReleaseProps> = observer(({ model, onClickLink }) => (
  <div className={styles.release}>
    <ReleaseHeader model={model} onClickLink={onClickLink} />

    {model.loading && <Loading text="Loading tracks" />}

    {!model.loading &&
      model.tracks.map((track) => <TrackLine key={track.identity} track={track} onClickLink={onClickLink} />)}
  </div>
));
